import type { ceresCatalogTypes } from '@debijenkorf/dbk-common';
import { formatPrices } from '@debijenkorf/price';
import { getProductImages, getProductTags } from '@debijenkorf/product-item';

import type { ProductCarouselItem } from '../ProductCarousel';

export type CatalogProduct = ceresCatalogTypes.components['schemas']['Product'];

export const mapCatalogProductToCarouselItem = (product: CatalogProduct): ProductCarouselItem => {
  const { currentVariantProduct } = product;

  const { src } = getProductImages({
    product: product as any,
    images: currentVariantProduct?.images,
    showHoverImage: false,
    showDetailImage: false,
  });
  const { tags, hasGift } = getProductTags(currentVariantProduct?.signings);

  return {
    productCode: product.code ?? '',
    code: currentVariantProduct?.code ?? '',
    title: product.brand?.name,
    subtitle: { name: product.subBrand?.name, url: product.subBrand?.relativeUrl },
    description: product.name,
    url: currentVariantProduct?.url,
    images: { mainImage: src, alt: product.displayName },
    tags,
    hasGift,
    isSponsored: Boolean(product.trackingMetadata?.rtmAttributionId),
    price: formatPrices({
      availableFromPrice: product.availableFromPrice,
      overriddenPrices: currentVariantProduct?.overriddenPrices || [],
      sellingPrice: currentVariantProduct?.sellingPrice || {},
      lowestPrice: currentVariantProduct?.lowestPrice,
      lowestPriceFlag: currentVariantProduct?.lowestPriceFlag,
    }),
  };
};
